import { fdb, auth } from "../services/firebase";
import store  from "../store";
class FireStore{
    constructor(){}

    saveContract(contractData){
        contractData.uid = store.state.user.uid;
        let contractCollection = fdb.collection(`/users/${store.state.user.uid}/contracts`);
        contractCollection.add(contractData)
        .then(()=>{
            console.log('Contract Saved successfuly');
          }).catch(err=>{
            console.log(err.message);
            
          })

    }

    getContracts(){
        let contractCollection = fdb.collection(`/users/${store.state.user.uid}/contracts`);
        contractCollection.get().then(function(querySnapshot) {
            console.log('got the contracts');
            
            store.commit('setContracts', querySnapshot.docs.map(doc => {
                let d = doc.data();
                d.docId= doc.id;
                return d;
            }));
            // this.setState({contracts: querySnapshot.docs.map(doc => doc.data())});//querySnapshot.docs.map(doc => doc.data())
          }.bind(this)).catch(err=>{
            console.log(err.message);
            
          })
    }

    getUserData(){
        let userData = fdb.doc(`/users/${store.state.user.uid}`);
        userData.get().then(doc=>{
            if(doc.exists){
                console.log('got user info');
                store.commit('setUserInfo', doc.data());
            }else{
                console.log('user info does not exists');
            }
        })
    }

}

export default new FireStore();


// WEBPACK FOOTER //
// ./src/helpers/db.js